'use strict';

var flyout = require('./flyout');

var COOKIE_NAME = 'state_picker_selection';
var COOKIE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;

function setSelectionCookie(stateCode) {
    try {
        document.cookie = COOKIE_NAME + '=' + encodeURIComponent(stateCode) +
            '; Max-Age=' + COOKIE_MAX_AGE_SECONDS +
            '; Path=/; SameSite=Lax; Secure';
    } catch (error) {
        // Cookie persistence is an enhancement and must not block the user's choice.
    }
}

function init() {
    var $popup = $('#state-picker-popup-flyout');

    if (!$popup.length) {
        return;
    }

    var $select = $popup.find('.state-picker-popup-select');
    var $proceed = $popup.find('.state-picker-popup-proceed');
    var dialog = $popup[0];

    function handleModalTab(event) {
        if (!dialog.open || event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) {
            return;
        }

        // Background popups can still intercept key events even when they are inert.
        // Handle Tab during capture, before their document-level focus traps.
        var $controls = $popup.find('button, select, input, textarea, a[href], [tabindex]')
            .filter(':visible')
            .filter(function () {
                return !$(this).is(':disabled') && this.tabIndex >= 0;
            });

        if (!$controls.length) {
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        var currentIndex = $controls.index(document.activeElement);
        var nextIndex = event.shiftKey ? currentIndex - 1 : currentIndex + 1;

        if (currentIndex === -1) {
            nextIndex = event.shiftKey ? $controls.length - 1 : 0;
        }

        $controls.get((nextIndex + $controls.length) % $controls.length).focus();
    }

    $popup.on('flyout:opened.statePickerPopup', function () {
        window.addEventListener('keydown', handleModalTab, true);
        // The top layer keeps later third-party popups behind this modal and inert.
        if (!dialog.open) {
            dialog.showModal();
        }
    });

    $popup.on('flyout:closed.statePickerPopup', function () {
        window.removeEventListener('keydown', handleModalTab, true);
        if (dialog.open) {
            dialog.close();
        }
    });

    $popup.on('cancel.statePickerPopup', function (event) {
        // Keep Escape on the same animation and cleanup path as the close button.
        event.preventDefault();
        flyout.closeflyout($popup);
    });

    function updateProceedState() {
        $proceed.prop('disabled', !$select.val());
    }

    $select.on('change.statePickerPopup', updateProceedState);

    $proceed.on('click.statePickerPopup', function () {
        var $selectedOption = $select.find('option:selected');
        var selectedStateCode = String($select.val() || '').trim().toUpperCase();

        if (!selectedStateCode) {
            updateProceedState();
            return;
        }

        var redirectRequired = $selectedOption.attr('data-redirect-required') === 'true';
        var destinationUrl = $selectedOption.attr('data-destination-url');

        setSelectionCookie(selectedStateCode);

        if (redirectRequired && destinationUrl) {
            window.location.assign(destinationUrl);
            return;
        }

        flyout.closeflyout($popup);
    });

    updateProceedState();
    flyout.openflyout($popup, {
        dismissOnOutsideClick: false,
        triggeredByKeyboard: true
    });
}

module.exports = {
    init: init
};
